export const TEMA_TOKENS = {
  namorados: {
    bodyBg:           'bg-[#0f0609]',
    headerBg:         'bg-[#0f0609]/90',
    headerBorder:     'border-rose-500/[0.18]',
    titulo:           'Jukebox dos Namorados',
    tituloColor:      'text-rose-300',
    badgeBg:          'bg-rose-500/15',
    badgeBorder:      'border-rose-500/25',
    accentColor:      'text-rose-400',
    progressGradient: 'from-rose-400 to-pink-500',
    fabGradient:      'from-rose-500 to-pink-600 shadow-rose-500/40',
    searchBtn:        'from-rose-500 to-pink-600',
    songBtnBg:        'bg-rose-500/15 group-hover:bg-rose-500/25',
    songBtnIcon:      'text-rose-400',
    emptyIcon:        'text-rose-500/20',
    queueIcon:        'text-rose-400/70',
    nowPlayingGlow:   '0 0 0 1px rgba(244,63,94,0.25), 0 25px 50px -12px rgba(0,0,0,0.6), inset 0 1px 0 rgba(255,255,255,0.08), inset 0 -1px 0 rgba(0,0,0,0.15)',
  },
  junina: {
    bodyBg:           'bg-[#110d00]',
    headerBg:         'bg-[#110d00]/90',
    headerBorder:     'border-amber-500/[0.15]',
    titulo:           'Jukebox Junino',
    tituloColor:      'text-amber-300',
    badgeBg:          'bg-amber-500/15',
    badgeBorder:      'border-amber-500/25',
    accentColor:      'text-amber-400',
    progressGradient: 'from-amber-400 to-orange-500',
    fabGradient:      'from-amber-500 to-orange-500 shadow-amber-500/40',
    searchBtn:        'from-amber-500 to-orange-500',
    songBtnBg:        'bg-amber-500/15 group-hover:bg-amber-500/25',
    songBtnIcon:      'text-amber-400',
    emptyIcon:        'text-amber-500/20',
    queueIcon:        'text-amber-400/70',
    nowPlayingGlow:   '0 0 0 1px rgba(245,158,11,0.25), 0 25px 50px -12px rgba(0,0,0,0.6), inset 0 1px 0 rgba(255,255,255,0.08), inset 0 -1px 0 rgba(0,0,0,0.15)',
  },
  copa: {
    bodyBg:           'bg-[#050f07]',
    headerBg:         'bg-[#050f07]/90',
    headerBorder:     'border-green-600/[0.20]',
    titulo:           'Jukebox da Copa',
    tituloColor:      'text-green-400',
    badgeBg:          'bg-green-600/15',
    badgeBorder:      'border-green-600/25',
    accentColor:      'text-green-400',
    progressGradient: 'from-green-500 to-emerald-400',
    fabGradient:      'from-green-600 to-yellow-500 shadow-green-600/40',
    searchBtn:        'from-green-600 to-yellow-500',
    songBtnBg:        'bg-green-600/15 group-hover:bg-green-600/25',
    songBtnIcon:      'text-green-400',
    emptyIcon:        'text-green-500/20',
    queueIcon:        'text-green-400/70',
    nowPlayingGlow:   '0 0 0 1px rgba(22,163,74,0.25), 0 25px 50px -12px rgba(0,0,0,0.6), inset 0 1px 0 rgba(255,255,255,0.08), inset 0 -1px 0 rgba(0,0,0,0.15)',
  },
} as const;

export type TemaNome = keyof typeof TEMA_TOKENS;

export const DEFAULT_TOKENS = {
  bodyBg:           'bg-jukebox-bg',
  headerBg:         'bg-jukebox-bg/90',
  headerBorder:     'border-white/[0.05]',
  titulo:           'Jukebox',
  tituloColor:      'text-white',
  badgeBg:          'bg-orange-500/15',
  badgeBorder:      'border-orange-500/20',
  accentColor:      'text-orange-400',
  progressGradient: 'from-orange-400 to-rose-400',
  fabGradient:      'from-orange-500 to-rose-500 shadow-orange-500/40',
  searchBtn:        'from-orange-500 to-rose-500',
  songBtnBg:        'bg-orange-500/15 group-hover:bg-orange-500/25',
  songBtnIcon:      'text-orange-400',
  emptyIcon:        'text-white/10',
  queueIcon:        'text-orange-400/70',
  nowPlayingGlow:   '0 0 0 1px rgba(249,115,22,0.15), 0 25px 50px -12px rgba(0,0,0,0.6), inset 0 1px 0 rgba(255,255,255,0.08), inset 0 -1px 0 rgba(0,0,0,0.15)',
} as const;

export type JukeboxTemaTokens = typeof TEMA_TOKENS[TemaNome] | typeof DEFAULT_TOKENS;

export function resolverTema(
  isInvasaoJunina: boolean,
  temaDiaNamorados: boolean,
  temaFestaJunina: boolean,
  temaCopa: boolean,
): { temaNome: TemaNome | null; tema: JukeboxTemaTokens } {
  const temaNome: TemaNome | null =
    isInvasaoJunina || temaFestaJunina ? 'junina'    :
    temaDiaNamorados                  ? 'namorados' :
    temaCopa                          ? 'copa'      :
    null;
  const tema = temaNome ? TEMA_TOKENS[temaNome] : DEFAULT_TOKENS;
  return { temaNome, tema };
}
